import { MODE_DEV, MODE_PROD } from 'root/settings'
import { getSchema } from '../utils'

export const ADDRESS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            address1: 'address1',
            address2: 'address2',
            postalCode: 'postalCode',
            city: 'city',
            optional: 'optional',
            province: 'province',
            country: 'country'
        }),
        [MODE_PROD]: Object.freeze({
            address1: 'a1',
            address2: 'a2',
            postalCode: 'pc',
            city: 'c',
            optional: 'o',
            province: 'p',
            country: 'co'
        })
    })
})()

export const HOURS = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            monday: 'monday',
            tuesday: 'tuesday',
            wednesday: 'wednesday',
            thursday: 'thursday',
            friday: 'friday',
            saturday: 'saturday',
            sunday: 'sunday'
        }),
        [MODE_PROD]: Object.freeze({
            monday: 'm',
            tuesday: 't',
            wednesday: 'w',
            thursday: 'th',
            friday: 'f',
            saturday: 's',
            sunday: 'su'
        })
    })
})()

export const ADMIN_FEE_RULES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            feeType: 'feeType',
            value: 'value',
            parameterField: 'parameterField',
            rangeStart: 'rangeStart',
            rangeEnd: 'rangeEnd'
        }),
        [MODE_PROD]: Object.freeze({
            feeType: 'ft',
            value: 'v',
            parameterField: 'pf',
            rangeStart: 'rs',
            rangeEnd: 're'
        })
    })
})()

export const DELIVERY_ADMIN_FEE_RULES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            feeType: 'feeType',
            value: 'value',
            parameterField: 'parameterField',
            rangeStart: 'rangeStart',
            rangeEnd: 'rangeEnd'
        }),
        [MODE_PROD]: Object.freeze({
            feeType: 'ft',
            value: 'v',
            parameterField: 'pf',
            rangeStart: 'rs',
            rangeEnd: 're'
        })
    })
})()

export const STORE_PROFILES = (() => {
    return getSchema({
        [MODE_DEV]: Object.freeze({
            name: 'name',
            address: 'address',
            phoneNumber: 'phoneNumber',
            website: 'website',
            hours: 'hours',
            bannerURL: 'bannerURL',
            logoURL: 'logoURL',
            visibility: 'visibility',
            approval: 'approval',
            courierId: 'courierId',
            provinceId: 'provinceId',
            brandId: 'brandId',
            adminFeeRules: 'adminFeeRules',
            deliveryAdminFeeRules: 'deliveryAdminFeeRules'
        }),
        [MODE_PROD]: Object.freeze({
            name: 'n',
            address: 'a',
            phoneNumber: 'pn',
            website: 'w',
            hours: 'h',
            bannerURL: 'bu',
            logoURL: 'lu',
            visibility: 'v',
            approval: 'ap',
            courierId: 'ci',
            provinceId: 'pi',
            brandId: 'bi',
            adminFeeRules: 'afr',
            deliveryAdminFeeRules: 'dafr'
        })
    })
})()
